export const dictionaryKeys = {
  readmore: 'readmore',
  tripAdvisorPreText: 'tripAdvisorPreText',
  numberOfReviewsLabel: 'numberOfReviewsLabel',
  readReviewLabel: 'readReviewLabel',
  writeReviewLabel: 'writeReviewLabel',
  reviewByLabel: 'reviewByLabel',
  tripAdvisorComponentTitle: 'TripAdvisorComponentDescription',
  tripAdvisorComponentDescription: 'TripAdvisorComponentDescription',
};
